<template>
  <div>
    <div
      v-for=" (item, index) in dataLog"
      :key="index"
      class="container-log">
      <b-row>
        <b-col md="2">
          <img
            :src="require(`@/assets/document/${item.status}.png`)"
            width="25">
        </b-col>
        <b-col md="10">
          <div class="d-flex">
            {{ item.roles_name }}
            <div
              v-if="item.nama_pegawai"
              class="log-nama-peagawai"> ( {{ item.nama_pegawai }} ) </div>
          </div>
          <div class="log-info-status">
            {{ item.info_status }} <br> {{ convertTime(item.date_time) }}
          </div>
        </b-col>
      </b-row>
      <div
        v-if="dataLog.length > (index + 1)"
        class="line-log" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars,import/no-unresolved,vue/require-default-prop,global-require,max-len,no-underscore-dangle */
import { mapActions } from 'vuex';
import axios from 'axios';

export default {
  props: {
    dataLog: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    convertTime(date) {
      if (date) {
        const timestamp = (new Date(Date.parse(date)).getTime());
        return this.$moment(new Date(timestamp)).format('DD MMMM YYYY');
      }
      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/log/jLog.vue